module.exports = __webpack_public_path__ + "media/middle-leaderboard-music.d121e7a0.mp3";